import React from 'react';
import Select from 'react-select';
import bemCn from 'bem-cn';
import './style.scss';

const b = bemCn('sniff-select');

const SniffSelect = ({ className, fullHeight, maxMenuHeight = 300, error, ...rest }, ref) => {
    return (
        <Select
            blurInputOnSelect={true}
            inputProps={{ readOnly: true }}
            isSearchable={false}
            searchable={false}
            classNamePrefix={b()}
            maxMenuHeight={fullHeight ? 'fit-content' : maxMenuHeight}
            minMenuHeight={fullHeight && 'fit-content'}
            ref={ref}
            className={`sniff-input ${b.mix(className).mix(error ? 'select-err' : '')}`}
            menuPlacement="auto"
            {...rest}
        />
    );
};

export default React.forwardRef(SniffSelect);
